import { render, staticRenderFns } from "./NewMoneyTable.vue?vue&type=template&id=6d7a60b6&scoped=true"
import script from "./NewMoneyTable.vue?vue&type=script&lang=js"
export * from "./NewMoneyTable.vue?vue&type=script&lang=js"
import style0 from "./NewMoneyTable.vue?vue&type=style&index=0&id=6d7a60b6&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=6d7a60b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a60b6",
  null
  
)

export default component.exports